export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Meet Your Pilot
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Hi, I'm Dario, a certified tandem paragliding instructor with over 10 years of experience. My passion for flying started when I was young, and now I have the privilege of sharing this incredible experience with people from all over the world.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Safety is my top priority. I hold all necessary certifications and regularly maintain my equipment to the highest standards. Every flight is carefully planned based on weather conditions to ensure you have the best and safest experience possible.
            </p>
            <div className="grid grid-cols-3 gap-6 mt-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-sky-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-award-fill text-3xl text-sky-600"></i>
                </div>
                <p className="font-semibold text-gray-900">10+ Years</p>
                <p className="text-sm text-gray-600">Experience</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-sky-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-user-smile-fill text-3xl text-sky-600"></i>
                </div>
                <p className="font-semibold text-gray-900">2000+</p>
                <p className="text-sm text-gray-600">Happy Flyers</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-sky-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-shield-check-fill text-3xl text-sky-600"></i>
                </div>
                <p className="font-semibold text-gray-900">100%</p>
                <p className="text-sm text-gray-600">Safety Record</p>
              </div>
            </div>
          </div>
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/08c2640151f695083ab8c8e95880d001.jpg"
              alt="Dario - Tandem Paragliding Instructor"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover object-top"
            />
            <div className="absolute -bottom-6 -right-6 bg-sky-600 text-white p-6 rounded-xl shadow-xl">
              <p className="text-3xl font-bold">Certified</p>
              <p className="text-sm">Tandem Pilot</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
